import { z } from 'zod'
import { oc } from '@orpc/contract'

/**
 * Manual Link resolution of a Match Review: a human attested that a candidate
 * returned by the retried TEFCA search is the chart's patient. Plain fields at
 * the boundary — never FHIR resources.
 */

const manualLinkInputSchema = z.object({
  patientId: z.string().min(1),
  /** The Health Gorilla id of the candidate being linked. */
  hgPatientId: z.string().min(1),
  /** Adopt all five of the candidate's Key Demographics into the chart. */
  updateChart: z.boolean(),
})

export const tefcaManualLink = oc
  .route({ method: 'POST', path: '/v2/tefca/manual-link' })
  .input(manualLinkInputSchema)
  .output(z.object({ success: z.boolean() }))
